/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/control-has-associated-label */

/* skeleton for dashboard */
import React from 'react';
import { Skeleton } from 'react-skeleton-generator';

function AdminUpdateSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider>
            <div className="pt-12">
                <div className="pb-[30px] border-b border-[#F2F2F3]">
                    <div className="flex w-full">
                        <div className="relative w-1/3">
                            <Skeleton />
                            <label htmlFor="empcode" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Employee Code *</label>
                        </div>
                        <div className="relative w-1/3 ml-8">
                            <Skeleton />
                            <label htmlFor="name" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">First Name *</label>
                        </div>
                        <div className="relative w-1/3 ml-8">
                            <Skeleton />
                            <label htmlFor="lname" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Last Name</label>
                        </div>
                    </div>
                    <div className="flex w-full pt-[26px]">
                        <div className="relative w-1/3">
                            <Skeleton />
                            <label htmlFor="email" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Email Address *</label>
                        </div>
                        <div className="relative w-1/3 ml-8">
                            <Skeleton />
                            <label htmlFor="mobilenumber" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Mobile Number *</label>
                        </div>
                        <div className="ml-8 dropdown relative w-1/3">
                            <Skeleton />

                        </div>
                    </div>
                </div>
                <div className="pt-[30px]">
                    <div className="flex">
                        <div className="dropdown relative w-2/5">
                            <div className="relative checkbox custom-checkbox custom-checkbox2 pb-3">
                                <Skeleton />
                            </div>
                        </div>
                        <div className="dropdown relative w-2/5 ml-8">
                            <Skeleton />
                        </div>
                    </div>
                    <div className="pt-[26px] flex">
                        <div className="dropdown relative w-2/5">
                            <Skeleton />

                        </div>
                        <div className="dropdown relative w-2/5 ml-8">
                            <Skeleton />

                        </div>
                    </div>
                    <div className="pt-2.5 flex hidden 3pl">
                        <div className="w-2/5 flex">
                            <div className="flex bg-[#F2F2F3] rounded-lg px-2 py-2 w-[120px] h-[33px] cursor-pointer">
                                <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" />
                            </div>
                            <div className="flex bg-[#F2F2F3] rounded-lg px-2 py-2 w-[110px] h-[33px] ml-4 cursor-pointer">
                                <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" />
                            </div>
                        </div>
                        <div className="w-2/5">
                            <div className="pl-5">
                                <div className="flex bg-[#F2F2F3] rounded-lg px-2 py-2 w-[110px] h-[33px] ml-4 cursor-pointer">
                                    <img src="/images/cross-mark.svg" alt="icon" className="pl-2 w-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pt-6">
                    <p className="text-sm font-bold text-[#090406]">Access Privileges</p>
                    <div className="pt-6">
                        {[...Array(6)].map((item, i) => (
                            <>
                                <div className="flex pb-3" key={`${i}-0`}>
                                    <div className="ml-8 dropdown relative w-1/3">
                                        <Skeleton />
                                    </div>
                                    <div className="ml-8 dropdown relative w-1/3">
                                        <Skeleton />
                                    </div>
                                    <div className="ml-8 dropdown relative w-1/3">

                                        <Skeleton />

                                    </div>
                                </div>
                                <br />
                            </>
                        ))}

                    </div>
                </div>
                <div className="flex justify-center pt-[34px]">
                    <Skeleton />
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>
    );
}

export default AdminUpdateSkeleton;
